// extracted by mini-css-extract-plugin
module.exports = {"form":"AddSocialAccountModal_form__qS4tC","actions":"AddSocialAccountModal_actions__yeufd"};